import { useState, useEffect } from 'react';
import axios from 'axios';
import CPFMaskInput from '../masks/CPFMaskInput';
import { API_BASE_URL } from '../../../config/ApiConfig';
import { unformatCPF, formatCPF, isValidCPF } from '../../utils/cpfUtils';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from './DefaultModal';

function UsuarioModal({ show, onClose, onSuccess, usuario }) {
  const [Usuario, setUsuario] = useState({
    cpf: '',
    nome: '',
    login: '',
    senha: '',
    situacao: '',
    role: '',
    cargo: '',
    email: '',
  });
  const [emailError, setEmailError] = useState('');
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (usuario) {
      setUsuario(usuario);
    } else {
      setUsuario({
        cpf: '',
        nome: '',
        login: '',
        senha: '',
        situacao: '',
        role: '',
        cargo: '',
        email: '',
      });
    }
  }, [usuario, show]);

  function handleChange(event) {
    const { name, value } = event.target;
    setUsuario({ ...Usuario, [name]: value });

    if (name === 'email') {
      validateEmail(value);
    }
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setEmailError('');
    } else if (!re.test(email)) {
      setEmailError('E-mail inválido');
    } else {
      setEmailError('');
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    if (!isValidCPF(Usuario.cpf)) {
      showDefaultModal('error', 'CPF inválido');
      return;
    }

    if (Usuario.email && emailError) {
      showDefaultModal('error', 'Por favor, corrija o e-mail antes de salvar');
      return;
    }

    const usuarioParaSalvar = {
      ...Usuario,
      cpf: unformatCPF(Usuario.cpf),
    };

    axios
      .post(`${API_BASE_URL.USUARIO}/salvar`, usuarioParaSalvar, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        if (onSuccess) onSuccess();
      });
  }

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: '90vw', height: '90vh' }}
        >
          <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background:
                  'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                padding: '0.35rem 0.75rem',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                  <i className="bi bi-person-plus me-2"></i>
                  {usuario ? 'Editar Usuário' : 'Cadastro de Usuário'}
                </h6>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-link text-white p-0 mb-0"
                    onClick={onClose}
                    title="Fechar"
                    style={{ fontSize: '1rem', textDecoration: 'none' }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body p-3" style={{ flex: 1, overflowY: 'auto' }}>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">CPF</label>
                    <CPFMaskInput
                      value={formatCPF(Usuario.cpf)}
                      onChange={e =>
                        handleChange({
                          target: {
                            name: 'cpf',
                            value: unformatCPF(e.target.value),
                          },
                        })
                      }
                      id="cpf"
                      name="cpf"
                      type="text"
                    />
                  </div>
                  <div className="col-md-8 input-group-sm">
                    <label className="form-label">Nome</label>
                    <input
                      onChange={handleChange}
                      value={Usuario.nome}
                      name="nome"
                      type="text"
                      className="form-control"
                    ></input>
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Login</label>
                    <input
                      onChange={handleChange}
                      value={Usuario.login}
                      name="login"
                      type="text"
                      className="form-control"
                    ></input>
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Senha</label>
                    <input
                      onChange={handleChange}
                      value={Usuario.senha}
                      name="senha"
                      type="password"
                      className="form-control"
                    ></input>
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Situação</label>
                    <select
                      onChange={handleChange}
                      value={Usuario.situacao}
                      name="situacao"
                      className="form-select"
                    >
                      <option value=""></option>
                      <option value="ATIVO">ATIVO</option>
                      <option value="INATIVO">INATIVO</option>
                    </select>
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Tipo de Usuário</label>
                    <select
                      onChange={handleChange}
                      value={Usuario.role}
                      name="role"
                      className="form-select"
                    >
                      <option value=""></option>
                      <option value="ADMIN">ADMINISTRADOR</option>
                      <option value="GEST">GESTOR</option>
                      <option value="USER">USUÁRIO</option>
                    </select>
                  </div>
                  <div className="col-md-8 input-group-sm">
                    <label className="form-label">E-mail</label>
                    <input
                      onChange={handleChange}
                      value={Usuario.email}
                      name="email"
                      type="email"
                      className={`form-control ${emailError ? 'is-invalid' : ''}`}
                    />
                    {emailError && (
                      <div className="invalid-feedback">{emailError}</div>
                    )}
                  </div>
                  <div className="col-md-8 input-group-sm">
                    <label className="form-label">Cargo / Função</label>
                    <input
                      onChange={handleChange}
                      value={Usuario.cargo}
                      name="cargo"
                      type="text"
                      className="form-control"
                    ></input>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={onClose}
              >
                <i className="bi bi-arrow-left" /> Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-success btn-sm"
                onClick={handleSubmit}
              >
                <i className="bi bi-check-lg" /> Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default UsuarioModal;
